export const getBlockStatusColor = (blockStatus: string) => {
  switch (blockStatus) {
    case 'NEW':
    case 'READY':
    case 'ACTIVE':
    case 'READY_TO_USE':
    case 'TRADE_IN':
    case 'PRE_ACTIVE':
      return 'green';
    case 'DEACTIVATED':
    case 'CANCELED':
    case 'BLOCKED':
    case 'REQUEST_CANCELED':
    case 'PROVISIONING_ERROR':
    case 'ICCID_NOT_FOUND':
    case 'PROVISIONING_CONTRACT_ERROR':
    case 'AGR_BLOCKED':
      return 'red';
    case 'SCHEDULED':
    case 'UPDATING':
    case 'SUSPENDED':
    case 'FROZEN':
    case 'MIGRATED':
    case 'PROVISIONING':
      return 'orange';
    case 'WAITING_SUSPENSION':
    case 'WAITING_REACTIVATION':
    case 'WAITING_CANCELLATION':
    case 'WAITING_SUBSTITUTION':
      return 'blue';
    default:
      return undefined;
  }
};
